import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import "../styles/Unbind.css";
import {
  getAllMerchants,
  resetTerminalPassword,
  unbindDevice,
} from "../api/api";
import { FaCreditCard } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";

// Validation
const validationSchema = Yup.object().shape({
  phone: Yup.string().required("PhoneNo. is required"),
});

const Operations = ({ isSidebarOpen }) => {
  const [loading, setLoading] = useState(true);
  const [allTerminals, setAllTerminals] = useState([]);

  // Fetch merchants and terminals
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllMerchants();
        if (res?.data) {
          const terminals = res.data.flatMap((merchant) =>
            merchant.terminals
              ? merchant.terminals.map((t) => ({
                  ...t,
                  merchantId: merchant.MID,
                  merchantName: merchant.MerchantName,
                }))
              : []
          );
          setAllTerminals(terminals);
        }
      } catch (err) {
        console.error("Error fetching merchants:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Formik setup
  const formik = useFormik({
    initialValues: { phone: "", tid: "" },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        // Send both PhoneNumber and TID
        const data = await resetTerminalPassword({
          phone: values.phone,
          tid: values.tid.TID,
        });

        if (data.isSuccess) {
          formik.resetForm();
          alert(`✅ Success: ${data.message}`);
        } else {
          alert(`❌ Error: ${data.message}`);
        }
      } catch (err) {
        alert(`❌ Error: ${err.message || err}`);
      } finally {
        setLoading(false);
      }
    },
  });

  // Loader UI
  if (loading && allTerminals.length > 0) {
    return (
      <div className="create-terminal-page">
        <p className="loader">Resetting Password...</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="create-terminal-page">
        <p className="loader">Fetching Terminal IDs...</p>
      </div>
    );
  }

  return (
    <div className={`reporting-container ${isSidebarOpen ? "shifted" : ""}`}>
      <form
        onSubmit={formik.handleSubmit}
        className="reporting-form"
        noValidate
      >
        {/* Terminal / Phone Dropdown */}
        <div className="form-group">
          <label>Select Terminal / Phone No</label>
          <div className="input-with-icon">
            <FaCreditCard className="input-icon" />
            {/* <Dropdown
              name="tid"
              value={formik.values.tid}
              options={allTerminals.map((t) => ({
                label: `${t.PhoneNumber} (${t.TID})`, // show phone + TID
                value: t.TID,                          // TID is value
                phone: t.PhoneNumber,                  // store phone
              }))}
              onChange={(e) => {
                formik.setFieldValue("tid", e.value);          // TID
                formik.setFieldValue("phone", e.option.phone); // PhoneNumber
              }}
              placeholder="Select Terminal / Phone"
              className="form-input"
              filter
              showClear
            /> */}
            <Dropdown
              name="tid"
              value={formik.values.tid} // store full object now
              options={allTerminals}
              optionLabel={(t) => `${t.PhoneNumber} (${t.TID})`} // what to show
              optionValue={(t) => t} // store the whole object
              onChange={(e) => {
                const terminal = e.value;
                formik.setFieldValue("tid", terminal || null);
                formik.setFieldValue(
                  "phone",
                  terminal ? terminal.PhoneNumber : ""
                );
              }}
              placeholder="Select Terminal / Phone"
              className="form-input"
              filter
              showClear
            />
          </div>
          {formik.touched.phone && formik.errors.phone && (
            <p className="error-message">{formik.errors.phone}</p>
          )}
        </div>

        {/* Submit Button */}
        <div className="form-actions">
          <button type="submit" className="report-btn apply" disabled={loading}>
            {loading ? "Processing..." : "Reset"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Operations;
